import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import {inject} from "mobx-react/index";

/**This class is special. It is used for properly displaying time blocks for when the
 * shop is closed.
 */
@inject('RootStore')
export default class TimeBlock extends Component {
    render() {
      let textColor = this.props.RootStore.styleStore.currentStylesDict.closedHoursTextColor;
      let {shrinked} = this.props
      let timeBlockStyle = {
        'paddingTop': '1%',
        'color': textColor || 'white',
        'fontSize': shrinked ? '1.5em' : '2.25em',
        'letterSpacing': '2.5%',
        'lineHeight': '1.25em',
        'fontFamily': 'GraphikLight'
      };

        return(
            <Flexbox style={timeBlockStyle}>
                {this.props.block}
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/live_order_stream_panel/time_block.jsx